import { observer } from 'mobx-react';

import { WIDGET_SAFE_ID_PREFIX } from '../../../../stores/event-trigger/constants';
import { isWithinRewardClaimWindow } from '../../../../utils/events';
import { useEventTriggerWidgetData } from '../../hooks';
import type { EventTriggerWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralSmallWidget, GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { EventTriggerWidgetTimer } from './EventTriggerWidgetTimer/EventTriggerWidgetTimer';

interface EventTriggerWidgetProps {
  sizeType: WidgetSizeType;
  data: EventTriggerWidgetDataType;
}

function EventTriggerWidgetComponent(props: EventTriggerWidgetProps) {
  const { data, sizeType } = props;
  const { event } = data;

  const { widgetImageUrl, handleClick } = useEventTriggerWidgetData({ event });

  const hideWidgetTimer =
    !event.canDisplay ||
    event.eventTrigger.hideWidgetTimer ||
    isWithinRewardClaimWindow(event.expiredAt, event.rewardClaimEndDate);

  const timer = hideWidgetTimer ? null : <EventTriggerWidgetTimer event={event} extended={sizeType === 'wide'} />;
  const smallWidgetExtended = !!timer;

  return (
    <WidgetWrapper
      id={`${WIDGET_SAFE_ID_PREFIX}${event.userEventTriggerId}`}
      sizeType={sizeType}
      smallWidgetExtended={smallWidgetExtended}
      onClick={handleClick}
    >
      {sizeType === 'small' ? (
        <GeneralSmallWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <GeneralWideWidget timer={timer} widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const EventTriggerWidget = observer(EventTriggerWidgetComponent);
